__turbopack_context__.v({
  "statBadge": "cJq6RG_statBadge",
});
